import React from 'react';
import { modal } from 'react-redux-modal';
import SendPlayerAlertModal from '../Modals/SendPlayerAlert';

const SendPlayerAlertButton = () => {
  const broadcast = () => {
    modal.add(SendPlayerAlertModal, {
      hideTitleBar: true,
      title: '',
      size: 'medium',
    });
  };
  return (
    <button className="btn btn-dark btn-block btn-sm-inline-block mt-0 mx-1" onClick={broadcast}>
      Send Player Alert
    </button>
  );
};

export default SendPlayerAlertButton;
